import { updateAnalysisView } from "@actions";
import { graphInitialState } from "@reducers/analysisViewReducer";
import React from "react";
import { connect } from "react-redux";
import { Button, ButtonGroup } from "semantic-ui-react";

const AnalysisGraphControls = (props) => {
  const { graphType, selectedRows, disabled } = props.analysis;
  return (
    <div
      className="flex-shrink mb-0_5 mt-0_5"
      style={{ verticalAlign: "middle" }}
    >
      <label className="font-bold mr-1">Graph Mode:</label>
      <ButtonGroup basic size="mini" compact>
        <Button
          active={graphType === 1}
          disabled={disabled}
          onClick={() =>
            props.updateAnalysisView({
              graphType: 1,
              selectedRows: [],
              graph: graphInitialState,
            })
          }
        >
          Standard
        </Button>
        <Button
          active={graphType === 2}
          disabled={disabled}
          onClick={() =>
            props.updateAnalysisView({
              graphType: 2,
              selectedRows: [],
            })
          }
        >
          MultiSelect
        </Button>
      </ButtonGroup>
      <small className="ml-0_5">
        {selectedRows.length} of {graphType === 1 ? 1 : 5} selected
      </small>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    analysis: state.analysisView,
  };
};

export default connect(mapStateToProps, {
  updateAnalysisView,
})(AnalysisGraphControls);
